// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"6a47da60","977":"2b245a02"}[chunkId] + ".chunk.js";
};